import { createContext, useContext, useState, ReactNode } from "react";
import { LayerTypeProviderProps } from "../../types";
import { useDemographicsData } from "./hooks/useDemographicsData";
import { SelectionFeature } from "src/js/stores/map/store";
import { SingleDesignation } from "react-migration/domains/constraints/typings/applicationTypes/SingleDesignation";
import { ConstraintsCategory } from "react-migration/layouts/map/Constraints/types";
import { DemographicsRegion } from "./types";
import { AttributeComparisonSummarySpec } from "./OutputAreaDetailView/OutputAreaDetailView";

interface DemographicsContextValue {
  selectedAttribute: string;
  setSelectedAttribute: (value: string) => void;
}

interface SiteReportDemographicsContextValue {
  targetDesignation?: SingleDesignation;
  designation?: SingleDesignation;
  superiorDesignations: SingleDesignation[];
  superiorCategories: ConstraintsCategory[];
  comparableDesignations: SingleDesignation[];
  topLevelDesignation?: SingleDesignation;
  defaultDesignationId?: string;

  region?: DemographicsRegion;
  attributeComparisonSpec?: AttributeComparisonSummarySpec;
  regionHierarchy: ConstraintsCategory[];

  loading: boolean;
}

const DemographicsContext = createContext({} as DemographicsContextValue);
const SiteReportDemographicsContext = createContext({} as SiteReportDemographicsContextValue);

export const useDemographicsContext = () => useContext(DemographicsContext);
export const useSiteReportDemographicsContext = () => useContext(SiteReportDemographicsContext);

export const DemographicsProvider = (props: LayerTypeProviderProps) => {
  const [selectedAttribute, setSelectedAttribute] = useState<string>("output_areas");

  return (
    <DemographicsContext.Provider
      value={{
        selectedAttribute,
        setSelectedAttribute,
      }}
    >
      {props.children}
    </DemographicsContext.Provider>
  );
};

interface SiteReportDemographicsProviderProps {
  children: ReactNode;
  selection: SelectionFeature;
}

export const SiteReportDemographicsProvider = ({ children, selection }: SiteReportDemographicsProviderProps) => {
  const demographicsData = useDemographicsData({
    selection,
    useIntersections: true,
  });

  return (
    <SiteReportDemographicsContext.Provider value={demographicsData}>{children}</SiteReportDemographicsContext.Provider>
  );
};
